import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';

@Component({
  selector: 'app-social-login',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './social-login.component.html',
  styleUrl: './social-login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialLoginComponent {
  public iconName = IconName;
}
